
import { inject, Injectable } from '@angular/core';
import { Data } from '@angular/router';
import mixpanel from 'mixpanel-browser';
import { MIXPANEL_ACCOUNT_ID } from "src/app/app.constants";
import { ClevertapService } from './clevertap.service';

@Injectable({
  providedIn: "root"
})
export class MixpanelService {

  mixpanel_account_id = MIXPANEL_ACCOUNT_ID;
  private isInitialized = false;

  /**
   * Initialize mixpanel.
   *
   * @param {string} userToken
   * @memberof MixpanelService
   */
  init(userId: string): void {
    mixpanel.init(this.mixpanel_account_id, { persistence: 'localStorage' });
    mixpanel.identify(userId);
    this.isInitialized = true;
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */
  track(id: string, action: any = {}): void {
    if (!this.isInitialized) {
      return;
    }
    mixpanel.track(id, action);
  }

  public clevertapService = inject(ClevertapService);
  public syndicateCancellationMixpanel(cancellation_step, cancellation_screen_name, click_type, button_name) {
    //Below script is for new syndicate cancellation flow.
    if (this.isInitialized) {
      mixpanel.track("Cancellation Click", {
        "cancellation_step": cancellation_step,
        "cancellation_screen_name": cancellation_screen_name,
        "click_type": click_type,
        "button_name": button_name
      });
    }
    // Below script is for clevertap cancellation flow
    this.clevertapService.cancellationClickedCleverTapEvent("Cancellation Click", {
      cancellation_step: cancellation_step,
      cancellation_screen_name: cancellation_screen_name,
      click_type: click_type,
      button_name: button_name,
    });
  }

  public getViewMixpanel(page_name) {
    if (!this.isInitialized) {
      return;
    }
    mixpanel.track('Page Viewed', {
      "page_name": page_name,
      "page_url": window.location.href,
      "title": page_name.charAt(0).toUpperCase() + page_name.slice(1).toLowerCase(),
      "path": window.location.pathname,
      "referrer": document.referrer,
      "search": window.location.search
    });
  }
  // Defined a method to track a sales event in Mixpanel
  public salesGerneryMixpanel(Store_Organic_Cash: string, eventbody?: Data) {
    if (!this.isInitialized) {
      return;
    }
    mixpanel.track(Store_Organic_Cash, {
      ...eventbody,
    });
  }
  // Defined a method to track a sales event in Mixpanel
  public GTMPopupInitializationForInboxNew(msg: string, body?: Data) {
    try {
      // Track the analytics event with the provided message and additional data (if any).
      if (typeof mixpanel.track !== "undefined" && this.isInitialized) {
        if (localStorage?.getItem("userId") === "null" || localStorage?.getItem("userId") === null) return;

        mixpanel.identify(localStorage?.getItem("userId"));

        mixpanel?.track(msg, {
          ...body,
        });
      }
    } catch (error) {
      return;
    }
  }
  // Traking Payment Holiday
  public trackPaymentHoliday(data: Data): void {
    if (!this.isInitialized) {
      return;
    }

    const creationDate = data?.next_resume_date;
    const date = creationDate
      ? new Date(creationDate?.seconds * 1000 + creationDate?.nanoseconds / 1e6).toISOString()
      : null;
    mixpanel.track("User_Payment_Holiday_Activated", {
      syndicateID: data?.syndicate_id,
      resumeDate: date,
    });
  }

  // Track one_click_pay payments
  public trackOneClickPayments(page_name: string) {
    const user_id = localStorage?.getItem("userId");
    if (!user_id || !this.isInitialized) return;

    mixpanel.identify(user_id);

    mixpanel.track("one_click_pay", {
      user_id: user_id,
      origin_page: page_name,
      date: new Date().toString(),
    });
  }

  // Discount Voucher Event Tracking
  public trackVoucherEvent(eventName: string, data: any) {
    const sessionId = sessionStorage.getItem("SessionId");
    const params = {
      session_id: sessionId,
      voucher_code: data?.voucherId ?? data?.voucher_code,
      timestamp: new Date().toISOString(),
    } as Data;
    mixpanel.track(eventName, params);
  }

  public checkListEvent(eventName: string, properties: Data = {}) {
    const params = {
      timestamp: Date.now(),
      device_info: navigator.userAgent,
      ...properties
    };
    mixpanel.track(eventName, params);
  }

  public trackMmAnalyticsEvent(eventName: string, payload: Data) {
    if (!eventName || !payload) return;
    const cleanPayload = Object.fromEntries(
      Object.entries({
        ...payload,
        userId: payload?.userId ?? "",
        timestamp: Date.now(), // optional but useful
      }).filter(([_, v]) => v !== undefined && v !== null)
    );
    mixpanel.track(eventName, cleanPayload);

  }

  public trackHomeScrollAnalyticsEvent(eventName: string, payload: Data) {
    if (!eventName || !payload) return;
    const cleanPayload = Object.fromEntries(
      Object.entries({
        ...payload,
        userId: payload?.userId ?? "",
        timestamp: Date.now(), // optional but useful
      }).filter(([_, v]) => v !== undefined && v !== null),
    );
    mixpanel.track(eventName, cleanPayload);
  }
}
